"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var error_1 = require("./lib/error");

var transaction_1 = require("./lib/transaction");

var ArweaveUtils = require("./lib/utils");

var Transactions =
/*#__PURE__*/
function () {
  function Transactions(api, crypto) {
    _classCallCheck(this, Transactions);

    this.api = api;
    this.crypto = crypto;
  }

  _createClass(Transactions, [{
    key: "getTransactionAnchor",
    value: function getTransactionAnchor() {
      return this.api.get("tx_anchor").then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "getPrice",
    value: function getPrice(byteSize, targetAddress) {
      var endpoint = targetAddress ? "price/".concat(byteSize, "/").concat(targetAddress) : "price/".concat(byteSize);
      return this.api.get(endpoint, {
        transformResponse: [
        /**
         * We need to specify a response transformer to override
         * the default JSON.parse behaviour, as this causes
         * winston to be converted to a number and we want to
         * return it as a winston string.
         * @param data
         */
        function (data) {
          return data;
        }]
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "get",
    value: function get(id) {
      return this.api.get("tx/".concat(id)).then(function (response) {
        if (response.status == 200 && response.data && response.data.id == id) {
          return new transaction_1.default(response.data);
        }

        if (response.status == 202) {
          throw new error_1.default("TX_PENDING"
          /* TX_PENDING */
          );
        }

        if (response.status == 404) {
          throw new error_1.default("TX_NOT_FOUND"
          /* TX_NOT_FOUND */
          );
        }

        if (response.status == 410) {
          throw new error_1.default("TX_FAILED"
          /* TX_FAILED */
          );
        }

        throw new error_1.default("TX_INVALID"
        /* TX_INVALID */
        );
      });
    }
  }, {
    key: "fromRaw",
    value: function fromRaw(attributes) {
      return new transaction_1.default(attributes);
    }
  }, {
    key: "search",
    value: function () {
      var _search = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(tagName, tagValue) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.api.post("arql", {
                  op: "equals",
                  expr1: tagName,
                  expr2: tagValue
                }).then(function (response) {
                  if (!response.data) {
                    return [];
                  }

                  return response.data;
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function search(_x, _x2) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }, {
    key: "getStatus",
    value: function getStatus(id) {
      return this.api.get("tx/".concat(id, "/status")).then(function (response) {
        if (response.status == 200) {
          return {
            status: 200,
            confirmed: response.data
          };
        }

        return {
          status: response.status,
          confirmed: null
        };
      });
    }
  }, {
    key: "getData",
    value: function getData(id, options) {
      return this.api.get("tx/".concat(id, "/data")).then(function (response) {
        if (response.status === 200) {
          var data = response.data;

          if (options && options.decode == true) {
            if (options && options.string) {
              return ArweaveUtils.b64UrlToString(data);
            }

            return ArweaveUtils.b64UrlToBuffer(data);
          }

          return data;
        }

        return null;
      });
    }
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(transaction, jwk) {
        var dataToSign, rawSignature, id;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dataToSign = transaction.getSignatureData();
                _context2.next = 3;
                return this.crypto.sign(jwk, dataToSign);

              case 3:
                rawSignature = _context2.sent;
                _context2.next = 6;
                return this.crypto.hash(rawSignature);

              case 6:
                id = _context2.sent;
                transaction.setSignature({
                  signature: ArweaveUtils.bufferTob64Url(rawSignature),
                  id: ArweaveUtils.bufferTob64Url(id)
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sign(_x3, _x4) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(transaction) {
        var signaturePayload, rawSignature, expectedId;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                signaturePayload = transaction.getSignatureData();
                /**
                 * The transaction ID should be a SHA-256 hash of the raw signature bytes, so this needs
                 * to be recalculated from the signature and checked against the transaction ID.
                 */

                rawSignature = transaction.get("signature", {
                  decode: true,
                  string: false
                });
                _context3.t0 = ArweaveUtils;
                _context3.next = 5;
                return this.crypto.hash(rawSignature);

              case 5:
                _context3.t1 = _context3.sent;
                expectedId = _context3.t0.bufferTob64Url.call(_context3.t0, _context3.t1);

                if (!(transaction.id !== expectedId)) {
                  _context3.next = 9;
                  break;
                }

                throw new Error("Invalid transaction signature or ID! The transaction ID doesn't match the expected SHA-256 hash of the signature.");

              case 9:
                return _context3.abrupt("return", this.crypto.verify(transaction.owner, signaturePayload, rawSignature));

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function verify(_x5) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }, {
    key: "post",
    value: function post(transaction) {
      return this.api.post("tx", transaction).then(function (response) {
        return response;
      });
    }
  }]);

  return Transactions;
}();

exports.default = Transactions;